import axios from 'utils/axios'

import { logoutTokenExpirado, criarAlerta } from 'actions'

export const VESTIGIO_SUCESSO = 'VESTIGIO_SUCESSO'
export const VESTIGIO_ERROR = 'VESTIGIO_ERROR'
export const ENCAMINHAR_VESTIGIO_SUCESSO = 'ENCAMINHAR_VESTIGIO_SUCESSO'
export const ENCAMINHAR_VESTIGIO_ERROR = 'ENCAMINHAR_VESTIGIO_ERROR'
export const FETCH_VESTIGIOS_CENTRAL_CUSTODIA = 'FETCH_VESTIGIOS_CENTRAL_CUSTODIA'
export const FETCH_VESTIGIOS_A_RECEBER_CENTRAL_CUSTODIA =
  'FETCH_VESTIGIOS_A_RECEBER_CENTRAL_CUSTODIA'
export const SET_PROCESSANDO_FETCH_VESTIGIOS_CENTRAL_CUSTODIA =
  'SET_PROCESSANDO_FETCH_VESTIGIOS_CENTRAL_CUSTODIA'
export const SET_VESTIGIO_TIMELINE = 'SET_VESTIGIO_TIMELINE'
export const setProcessandoVestigiosCentralCustodia = (value) => async (dispatch) => {
  dispatch({
    type: SET_PROCESSANDO_FETCH_VESTIGIOS_CENTRAL_CUSTODIA,
    isProcessandoVestigiosCentralCustodia: value,
  })
}

export const fetchVestigiosCentralCustodia = (id, router) => async (dispatch) => {
  dispatch(setProcessandoVestigiosCentralCustodia(true))
  try {
    const response = await axios.get(`vestigios/centraldecustodia/${id}`)
    dispatch({
      type: FETCH_VESTIGIOS_CENTRAL_CUSTODIA,
      vestigiosCentralCustodia: response.data.vestigios,
    })
  } catch (error) {
    if (error.response.status === 401) {
      dispatch(logoutTokenExpirado(router))
    } else {
      dispatch(criarAlerta(error.response, router, '/centraldecustodia'))
    }
  }
  dispatch(setProcessandoVestigiosCentralCustodia(false))
}

export const fetchVestigiosAReceberCentralCustodia = (id, router) => async (dispatch) => {
  dispatch(setProcessandoVestigiosCentralCustodia(true))
  try {
    const response = await axios.get(`centraldecustodia/vestigiosareceber/${id}`)
    dispatch({
      type: FETCH_VESTIGIOS_A_RECEBER_CENTRAL_CUSTODIA,
      vestigiosAReceberCentralCustodia: response.data.vestigios,
    })
  } catch (error) {
    if (error.response.status === 401) {
      dispatch(logoutTokenExpirado(router))
    } else {
      dispatch(criarAlerta(error.response, router, '/centraldecustodia'))
    }
  }
  dispatch(setProcessandoVestigiosCentralCustodia(false))
}
